import { BellIcon } from "icons";
import { Badge, IconButton, Tooltip } from "@mui/material";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { useNotificationCount } from "hooks";

const NotificationCount: FC = () => {
  const count = useNotificationCount();
  return (
    <Tooltip title="Notifications" aria-label="notifications">
      <IconButton color="primary"
        component={Link} to="/notifications" sx={{
          "@media (max-width: 959px)": {
            display: "none"
          }
        }}
        data-tut="reactour__bell_notification"
      >
        <Badge badgeContent={count} color="error">
          <BellIcon />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default NotificationCount;
